import { useUserContext } from "@/components/user-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { DevAIBetaDeprecated } from "../beta-deprecated";

import { LoggedInDevAIFree } from "./free/logged-in-devai-free";
import { LoggedInRovoDevStandard } from "./standard";

export const LoggedInDevAI = () => {
    const { edition } = useUserContext();

    if (
        edition === "free" &&
        checkFeatureFlagGate(featureFlags.enableRovoDevBetaSignup)
    ) {
        return <LoggedInDevAIFree />;
    }

    if (checkFeatureFlagGate(featureFlags.enableRovoDevStandardSignup)) {
        return <LoggedInRovoDevStandard />;
    }

    return <DevAIBetaDeprecated />;
};
